export default __webpack_public_path__ + "static/media/Screenshot-Illustration.89f4db7c.png";